import { WebBoosterType } from '../models/UserStore';

import { Images } from './images';
import { SVGIconType } from './svgIcon';

type BoosterVairant = {
  name: string;
  icon: SVGIconType;
  fullName: string;
  description: string;
  neverForgetText: string;
  textToPractice: string;
  createTextGame: string;
  shortCreateName: string;
  shareBooster: string;
  backgroundImage: string;
  classVariant: string;
  practiceName: string;
};

const boosterVairant: Record<WebBoosterType, BoosterVairant> = {
  [WebBoosterType.Normal]: {
    name: 'Text Memory Booster',
    icon: SVGIconType.ScoreA,
    fullName: 'Text Memory Booster · Space',
    description: 'Memorize Any Knowledge!',
    neverForgetText: 'Never Forget Any Knowledge!',
    textToPractice:
      'Enter vocabulary, sentences or paragraphs e.g. Creativity is intelligence having fun. Albert Einstein',
    createTextGame: 'Create the Journey of Memory Practice',
    shortCreateName: 'Knowledge',
    shareBooster: 'Share Text Memory Booster',
    backgroundImage: Images.BannerBackgroundEffect,
    classVariant: 'normalBooster',
    practiceName: 'Knowledge to Memory Practice',
  },
  [WebBoosterType.Bible]: {
    name: 'Bible Memory Booster',
    icon: SVGIconType.Bible,
    fullName: 'Bible Memory Booster · Space',
    description: 'Memorize Any Scripture!',
    neverForgetText: "Never Forget God's Word!",
    textToPractice:
      'Input Bible scripture or content for sharing e.g. Proverbs 4:5 (NIV)',
    createTextGame: 'Create the Journey of AI Bible Memory Practice',
    shortCreateName: 'Scripture',
    shareBooster: 'Share Bible Memory Booster',
    backgroundImage: Images.BibleBoosterBG,
    classVariant: 'bibleBooster',
    practiceName: 'Scripture to Memory Practice',
  },
};

export const getWebBoosterVairant = (
  boosterType: WebBoosterType = WebBoosterType.Normal,
) => {
  return boosterVairant[boosterType];
};
